import { TOURNAMENT_GAME_RESULT } from "../constants";
export const randomGameResult = () => {
    const r = Math.random();
    if (r < 0.4) {
        return {
            whiteResult: TOURNAMENT_GAME_RESULT.WIN,
            blackResult: TOURNAMENT_GAME_RESULT.LOSS,
        };
    }
    if (r < 0.8) {
        return {
            whiteResult: TOURNAMENT_GAME_RESULT.LOSS,
            blackResult: TOURNAMENT_GAME_RESULT.WIN,
        };
    }
    return {
        whiteResult: TOURNAMENT_GAME_RESULT.DRAW,
        blackResult: TOURNAMENT_GAME_RESULT.DRAW,
    };
};
